import React from "react";
import { css } from "@emotion/react";
import { Textarea } from "baseui/textarea";

export interface TextareaInputProps {
  onChangeText: (value: string) => void;
  value: string;
  placeholder: string;
  containerStyle?: React.CSSProperties;
  useFullHeight?: boolean;
  label?: string;
  disabled?: boolean;
}

const TextareaInput: React.FC<TextareaInputProps> = (props) => {
  return (
    <div css={props.label && styles.wrapper}>
      {props.label && (
        <label
          css={{
            paddingTop: props.containerStyle?.paddingTop,
            marginBottom: "2px",
          }}>
          {props.label}
        </label>
      )}
      <Textarea
        disabled={props.disabled}
        onChange={(event) => props.onChangeText(event.currentTarget.value)}
        value={props.value}
        placeholder={props.placeholder}
        overrides={{
          InputContainer: {
            style: () => ({
              backgroundColor: "#fff",
              borderTopWidth: "0",
              borderRightWidth: "0",
              borderBottomWidth: "0",
              borderLeftWidth: "0",
              outline: "none",
              boxShadow: "none",
              display: props?.containerStyle?.display,
              flexDirection: props?.containerStyle?.flexDirection,
            }),
          },
          Input: {
            style: () => ({
              height: "160px",
              paddingTop: "10px",
              paddingRight: "10px",
              paddingBottom: "10px",
              paddingLeft: "10px",
              fontFamily: "SourceSansPro-Regular",
            }),
          },
        }}
      />
    </div>
  );
};

const styles = {
  wrapper: css({
    display: "flex",
    flexDirection: "column",
  }),
};

export default TextareaInput;
